import { render, staticRenderFns } from "./SelectTipoEstaticos.vue?vue&type=template&id=51470eb3"
import script from "./SelectTipoEstaticos.vue?vue&type=script&lang=js"
export * from "./SelectTipoEstaticos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports